export default __webpack_public_path__ + "static/media/NID_guide.acd65406.png";